import {Location} from 'react-router-dom';
import styled from '@emotion/styled';
import { observer } from "mobx-react-lite";
import { useState } from 'react';
import './Marketplace.css';

import {useStores} from '../stores/useStores';

import MarketItem from './MarketItem';
import MarketFilter from './MarketFilter';
import MarketEmptyItem from './MarketEmptyItem';

// import InfiniteScroll from 'react-infinite-scroller';
import Tabs from './Tabs';
import CardStore from 'src/stores/CardStore';

interface IMarketplaceProps {
    location?: Location;
    burn?: boolean;
}

enum TABS {
    VERIFY='Verified',
    UNVERIFY='Unverified'
}

const TabsWrap = styled.div`
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    @media only screen and (min-width : 1200px) {
        width: 1160px;
        margin: 0 auto;
    }
`;

export default observer(function(props: IMarketplaceProps) {
    const { marketStore } = useStores();
    const pageLimit = 24;
    const [pageIndex, setPageIndex] = useState<number>(1);

    const [activeTab, setActiveTab] = useState<TABS>(TABS.VERIFY);

    const verified: CardStore[] = [];
    const unverified: CardStore[] = [];

    marketStore.filteredItems.forEach((item) => {
        if (item.verified) verified.push(item);
        else unverified.push(item);
    });

    const marketItems = activeTab === TABS.VERIFY ? verified : unverified;

    const tabs = [{
        id: TABS.VERIFY,
        title: 'Verified',
        count: verified.length,
        active: activeTab === TABS.VERIFY,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }, {
        id: TABS.UNVERIFY,
        title: 'Unverified',
        count: unverified.length,
        active: activeTab === TABS.UNVERIFY,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }];

    return (
        <div className='nftMarketplace-pageWrapper'>
            <h1 className='nftMarketplace-title'>Explore Puzzle Market</h1>
            <div className='nftMarketplace-desc'>Puzzle Market is place where you can create, buy and sell NFTs</div>
            <TabsWrap>
                <Tabs align="left" noBorder={true} tabs={tabs}/>
            </TabsWrap>
            <MarketFilter
                total={ marketStore.filteredItems.length } />
            <div className='puzzle-nftMarketplace'>
                {
                    marketStore.filteredItems.length ?
                    marketItems.slice(0, pageIndex * pageLimit).map((item) => <MarketItem key={item.assetId} burn={props.burn} item={item}/>) :
                        marketStore.isLoading ?
                            [1].map((key) => <MarketEmptyItem key={key}/>) : 'No data'
                }
            </div>
            {
                marketItems[pageIndex * pageLimit] ?
                    <div className='nftMarketplace-loadMore' onClick={() => { setPageIndex(pageIndex + 1) }}>
                        <button className="puzzle-nftMarketplace__button puzzle-nftMarketplace__button_cancel">Load more...</button>
                    </div> :
                    ''
            }
        </div>
    );
});
